export default __webpack_public_path__ + "static/media/megaphonesvg.42912b73.svg";